export const LAST_PROMPT_STORAGE_KEY = "theecastable_last_prompt";
export const LAST_PROMPT_EVENT = "theecastable:last-prompt";

/** Last question the user opened, as { id, title }, or null. */
export function readLastPrompt() {
    try {
        const raw = localStorage.getItem(LAST_PROMPT_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : null;
        return parsed?.id ? parsed : null;
    } catch {
        return null;
    }
}
